module.exports = __webpack_public_path__ + "static/media/Dreamer maxihörnsoffa sense 4060 ljusgrå miljö 2024.b42cbd83.jpg";